import { render } from "./COIActionBarDirectStocking.vue?vue&type=template&id=03dbfc13"
import script from "./COIActionBarDirectStocking.vue?vue&type=script&lang=js"
export * from "./COIActionBarDirectStocking.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__